import React, { useState, useEffect } from 'react';

import ReactApexChart from 'react-apexcharts';



const PopulationChart = ({ data }) => {
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedPradesh, setSelectedPradesh] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedMandal, setSelectedMandal] = useState('');
    const [graphData, setGraphData] = useState(data[0].data); // Default: All Country
    const [chartSeries, setChartSeries] = useState([{ data: [] }]); // For ApexCharts series
    const [chartOptions, setChartOptions] = useState({ // For ApexCharts options
        chart: {
            height: 350,
            type: 'bar',
            distributed: true, // Key: Enable distributed columns
            events: {
                click: function (chart, w, e) {
                    // console.log(chart, w, e)
                }
            }
        },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#A8B08C', '#826BF6', '#29D9D5'],
        plotOptions: {
            bar: {
                columnWidth: '45%',
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    fontSize: '12px'
                }
            }
        }
    });


    useEffect(() => {
        updateChartData();  // Call this to update ApexCharts data
    }, [selectedCountry, selectedState, selectedPradesh, selectedCity, selectedMandal]);


    const updateChartData = () => {
        let currentData;

        if (selectedMandal) {
            const selectedCountryData = data.find(c => c.name === selectedCountry);
            const selectedStateData = selectedCountryData.state.find(s => s.name === selectedState);
            const selectedPradeshData = selectedStateData.pradesh.find(p => p.name === selectedPradesh);
            const selectedCityData = selectedPradeshData.city.find(ci => ci.name === selectedCity);
            currentData = selectedCityData.mandal.find(m => m.name === selectedMandal).data;
        } else if (selectedCity) {
            const selectedCountryData = data.find(c => c.name === selectedCountry);
            const selectedStateData = selectedCountryData.state.find(s => s.name === selectedState);
            const selectedPradeshData = selectedStateData.pradesh.find(p => p.name === selectedPradesh);
            currentData = selectedPradeshData.city.find(ci => ci.name === selectedCity).data;
        } else if (selectedPradesh) {
            const selectedCountryData = data.find(c => c.name === selectedCountry);
            const selectedStateData = selectedCountryData.state.find(s => s.name === selectedState);
            currentData = selectedStateData.pradesh.find(p => p.name === selectedPradesh).data;
        } else if (selectedState) {
            const selectedCountryData = data.find(c => c.name === selectedCountry);
            currentData = selectedCountryData.state.find(s => s.name === selectedState).data;
        } else if (selectedCountry) {
            currentData = data.find(c => c.name === selectedCountry).data;
        } else {
            currentData = data[0].data;
        }

        const categories = Object.keys(currentData).filter(key => key !== 'total'); // Categories
        const dataValues = categories.map(category => currentData[category]); // Data values

        setChartSeries([{ data: dataValues }]); // Update ApexCharts series
        setChartOptions(prevOptions => ({
            ...prevOptions,
            xaxis: {
                ...prevOptions.xaxis,
                categories: categories
            },
            colors: categories.map((_, index) => prevOptions.colors[index % prevOptions.colors.length]) // Assign colors dynamically
        }));

        setGraphData(currentData); // Keep this for the Chart.js chart if you still use it
    };


    const handleCountryChange = (event) => {
        setSelectedCountry(event.target.value);
        setSelectedState(''); // Clear state
        setSelectedPradesh(''); // Clear pradesh
        setSelectedCity('');    // Clear city
        setSelectedMandal('');  // Clear mandal
    };

    const handleStateChange = (event) => {
        setSelectedState(event.target.value);
        setSelectedPradesh(''); // Clear pradesh
        setSelectedCity('');    // Clear city
        setSelectedMandal('');  // Clear mandal
    };

    const handlePradeshChange = (event) => {
        setSelectedPradesh(event.target.value);
        setSelectedCity('');    // Clear city
        setSelectedMandal('');  // Clear mandal
    };

    const handleCityChange = (event) => {
        setSelectedCity(event.target.value);
        setSelectedMandal('');  // Clear mandal
    };
    const handleMandalChange = (event) => {  // The missing function!
        setSelectedMandal(event.target.value);
    };



    const getStates = () => {
        if (!selectedCountry) return []; // Return empty array if no country selected
        const selectedCountryData = data?.find(c => c.name === selectedCountry);
        return selectedCountryData?.state || [];
    };

    const getPradeshes = () => {
        if (!selectedState || !selectedCountry) return []; // Check both state and country
        const selectedCountryData = data?.find(c => c.name === selectedCountry);
        const selectedStateData = selectedCountryData?.state?.find(s => s.name === selectedState);
        return selectedStateData?.pradesh || [];
    };

    const getCities = () => {
        if (!selectedPradesh || !selectedState || !selectedCountry) return []; // Check all
        const selectedCountryData = data?.find(c => c.name === selectedCountry);
        const selectedStateData = selectedCountryData?.state?.find(s => s.name === selectedState);
        const selectedPradeshData = selectedStateData?.pradesh?.find(p => p.name === selectedPradesh);
        return selectedPradeshData?.city || [];
    };

    const getMandals = () => {
        if (!selectedCity || !selectedPradesh || !selectedState || !selectedCountry) return []; // Check all
        const selectedCountryData = data?.find(c => c.name === selectedCountry);
        const selectedStateData = selectedCountryData?.state?.find(s => s.name === selectedState);
        const selectedPradeshData = selectedStateData?.pradesh?.find(p => p.name === selectedPradesh);
        const selectedCityData = selectedPradeshData?.city?.find(ci => ci.name === selectedCity);
        return selectedCityData?.mandal || [];
    };



    return (
        <div>

            <div class='row col-11'>

                <div class='col-lg-4 col-md-6 col-11 mt-3 '>
                    <label htmlFor="country">Country : {selectedCountry} </label>
                    <select class='form-select' id='country' value={selectedCountry} onChange={handleCountryChange}>
                        <option value="">Select Country</option>
                        {data.map((country) => (
                            <option key={country.name} value={country.name}>
                                {country.name}
                            </option>
                        ))}
                    </select>
                </div>

                {
                    selectedCountry &&
                    <div class='col-lg-4 col-md-6 col-11 mt-3 '>
                        <label htmlFor="country">State : {selectedState} </label>
                        <select class='form-select' value={selectedState} onChange={handleStateChange}>
                            <option value="">Select State</option>
                            {getStates().map((state) => (
                                <option key={state.name} value={state.name}>
                                    {state.name}
                                </option>
                            ))}
                        </select>
                    </div>
                }
                {
                    selectedState &&
                    <div class='col-lg-4 col-md-6 col-11 mt-3 '>
                        <label htmlFor="country">Pradesh : {selectedPradesh} </label>
                        <select class='form-select' value={selectedPradesh} onChange={handlePradeshChange}>
                            <option value="">Select Pradesh</option>
                            {getPradeshes().map((pradesh) => (
                                <option key={pradesh.name} value={pradesh.name}>
                                    {pradesh.name}
                                </option>
                            ))}
                        </select>
                    </div>
                }
                {
                    selectedPradesh &&
                    <div class='col-lg-4 col-md-6 col-11 mt-3 '>
                        <label htmlFor="country">City : {selectedCity} </label>
                        <select class='form-select' value={selectedCity} onChange={handleCityChange}>
                            <option value="">Select City</option>
                            {getCities().map((city) => (
                                <option key={city.name} value={city.name}>
                                    {city.name}
                                </option>
                            ))}
                        </select>
                    </div>
                }
                {
                    selectedCity &&
                    <div class='col-lg-4 col-md-6 col-11 mt-3 '>
                        <label htmlFor="country">Mandal : {selectedMandal} </label>
                        <select class='form-select' value={selectedMandal} onChange={handleMandalChange}>
                            <option value="">Select Mandal</option>
                            {getMandals().map((mandal) => (
                                <option key={mandal.name} value={mandal.name}>
                                    {mandal.name}
                                </option>
                            ))}
                        </select>
                    </div>
                }
            </div>

            <div style={{ width: '100%', height: '400px' }}>
                <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={350} />
            </div>
        </div>
    );
};

export default PopulationChart;